import Base from './base'
import urls from 'config/urls'

class Vote extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.vote.find,
      data: opts
    })
  }

  get (opts) {
    return this.httpGet({
      url: urls.vote.get,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.vote.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.vote.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.vote.delete,
      data: opts
    })
  }

  findBanner (opts) {
    return this.httpGet({
      url: urls.vote.findBanner,
      data: opts
    })
  }

  createBanner (opts) {
    return this.httpPost({
      url: urls.vote.createBanner,
      data: opts
    })
  }

  updateBanner (opts) {
    return this.httpPost({
      url: urls.vote.updateBanner,
      data: opts
    })
  }

  deleteBanner (opts) {
    return this.httpPost({
      url: urls.vote.deleteBanner,
      data: opts
    })
  }

  findPrize (opts) {
    return this.httpGet({
      url: urls.vote.findPrize,
      data: opts
    })
  }

  createPrize (opts) {
    return this.httpPost({
      url: urls.vote.createPrize,
      data: opts
    })
  }

  updatePrize (opts) {
    return this.httpPost({
      url: urls.vote.updatePrize,
      data: opts
    })
  }

  deletePrize (opts) {
    return this.httpPost({
      url: urls.vote.deletePrize,
      data: opts
    })
  }

  findPrizeXref (opts) {
    return this.httpGet({
      url: urls.vote.findPrizeXref,
      data: opts
    })
  }

  createPrizeXref (opts) {
    return this.httpPost({
      url: urls.vote.createPrizeXref,
      data: opts
    })
  }

  updatePrizeXref (opts) {
    return this.httpPost({
      url: urls.vote.updatePrizeXref,
      data: opts
    })
  }

  deletePrizeXref (opts) {
    return this.httpPost({
      url: urls.vote.deletePrizeXref,
      data: opts
    })
  }

  findPresentAll (opts) {
    return this.httpGet({
      url: urls.vote.findPresentAll,
      data: opts
    })
  }

  createPresent (opts) {
    return this.httpPost({
      url: urls.vote.createPresent,
      data: opts
    })
  }

  updatePresent (opts) {
    return this.httpPost({
      url: urls.vote.updatePresent,
      data: opts
    })
  }

  deletePresent (opts) {
    return this.httpPost({
      url: urls.vote.deletePresent,
      data: opts
    })
  }

  findPresentXref (opts) {
    return this.httpGet({
      url: urls.vote.findPresentXref,
      data: opts
    })
  }

  createPresentXref (opts) {
    return this.httpPost({
      url: urls.vote.createPresentXref,
      data: opts
    })
  }

  updatePresentXref (opts) {
    return this.httpPost({
      url: urls.vote.updatePresentXref,
      data: opts
    })
  }

  deletePresentXref (opts) {
    return this.httpPost({
      url: urls.vote.deletePresentXref,
      data: opts
    })
  }

  findPresentOrder (opts) {
    return this.httpGet({
      url: urls.vote.findPresentOrder,
      data: opts
    })
  }

  deletePresentOrder (opts) {
    return this.httpPost({
      url: urls.vote.deletePresentOrder,
      data: opts
    })
  }

  findResult (opts) {
    return this.httpGet({
      url: urls.vote.findResult,
      data: opts
    })
  }

  deleteResult (opts) {
    return this.httpPost({
      url: urls.vote.deleteResult,
      data: opts
    })
  }

  findPlayerAll (opts) {
    return this.httpGet({
      url: urls.vote.findPlayerAll,
      data: opts
    })
  }

  deletePlayer (opts) {
    return this.httpPost({
      url: urls.vote.deletePlayer,
      data: opts
    })
  }

  downloadQRCode (opts) {
    return this.httpDownload({
      url: urls.vote.downloadQRCode,
      data: opts
    })
  }
}

export default new Vote



// WEBPACK FOOTER //
// ./src/models/vote.js